export enum PayBy {
  payByGroup = 'Pay by Group',
  payByMasterAgent = 'Pay by Master Agent',
}
